export const commonVar = {
    appVersion: '0.33.4-SNAPSHOT',
    axonautSupportEmail :'axonaut@support.com',
    calendarUrl: "https://calendar.app.google/dQzPqrJy8StMut6HA",
    schedulingUrl: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ2HzIiGqtn-XB9xnJuSONqkHmp8-Had7ydW8nZpIA78FZhDIXpq2nmXc5PSI9MkAyfYL6OCc7ws?gv=true',
    storyToDocUrl: 'https://play.storytodoc.ai/center/13bdbd54-098b-11f0-b752-367927d11b38?language=fr',
}